import { AxiosError } from 'axios'

export function isAxiosError<T>(obj: unknown): obj is AxiosError<T> {
   return (obj as AxiosError<T>).response !== undefined
}
